exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "* {\n  background: #532F8C !important;\n  color: white !important;\n}\n", ""]);

